// Captures missing translation keys, persists them, and kicks off auto-translation.
// Debounced batching avoids spamming the edge function.

import { supabase } from "@/integrations/supabase/client";

const seen = new Set<string>();
const pending = new Set<string>();
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function scheduleInvoke() {
  if (flushTimer) return;
  flushTimer = setTimeout(async () => {
    flushTimer = null;
    if (pending.size === 0) return;
    const keys = Array.from(pending);
    pending.clear();
    try {
      await supabase.functions.invoke("auto-translate", { body: { keys } });
    } catch (e) {
      // Cron will retry.
      console.warn("[i18n] auto-translate invoke failed", e);
    }
  }, 2000);
}

export const handleMissingTranslation = async (
  _lngs: readonly string[],
  namespace: string,
  key: string,
  res: string,
) => {
  if (seen.has(key)) return;
  seen.add(key);

  try {
    const { error } = await (supabase as any).from("translation_queue").insert({
      translation_key: key,
      default_text: res || key,
      context: `Namespace: ${namespace}`,
    });
    if (error && error.code !== "23505") {
      console.warn("[i18n] enqueue failed", error);
      return;
    }
    pending.add(key);
    scheduleInvoke();
  } catch (err) {
    console.warn("[i18n] missing handler error", err);
  }
};
